import styled from 'styled-components';
import {Button} from "@mui/material";

export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 28px 32px 16px;
    flex-shrink: 0;
    gap: 16px;
`;

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 959px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 22px;
    }
`

export const HeaderTitle = styled.h2`
    flex: 1;
    margin: 0;
    padding-right: 4px;
`;

export const StyledHeaderActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 2;
    gap: 12px;
    width: 100%;
    
    @media (max-width: 1200px) {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }
`;

export const StyledFilterButton = styled(Button)`
    && {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: 6px;
        cursor: pointer;

        @media (max-width: 1200px) {
            width: 100%;
        }
    }
`;